import { render } from "./CarruselServicios.vue?vue&type=template&id=6e957492&scoped=true"
import script from "./CarruselServicios.vue?vue&type=script&lang=js"
export * from "./CarruselServicios.vue?vue&type=script&lang=js"

import "./CarruselServicios.vue?vue&type=style&index=0&id=6e957492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e957492"]])

export default __exports__